import { Dialog, DialogContent, DialogActions, Button, Backdrop  } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../Components/CustomSnackbar';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import React, {useState, useEffect, useRef }from 'react';
import { CONST_CANTON, FOB_FLAG, PON_BOX, PON_BOX_FLAG } from '../../Constants/ConstantsOptics';
import { SERVICE_HOUSE_URL, NETSTAT_SWITCH_URL, GET_KTV_AMPLIFIER_API_URL, GET_KTV_AMPLIFIER_OP_NODE_API_URL, GET_DIVIDER_NODE_API_URL, GET_CASSETTE_NODE_API_URL, GET_RESERVE_NODE_API_URL } from '../../OpticApiConfig';
import PonBoxEditingDialogNode from './DialogEditingNode/PonBoxEditingDialogNode';
import { GET_PON_BOX_CANTON_NODE_API_URL } from '../../OpticApiConfig';
import { HOUSE, HOUSE_FLAG, ROLE_ADMIN, ROLE_ENGINNER } from '../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../Modal/ModalDescriptionComponentSpecifically';
import KtvEditingDialogNode from './DialogEditingNode/KtvEditingDialogNode';
import axios from 'axios';
import DialogNodeFotoEditing from './DialogNodeFotoEditing';
import { fetchNodeFileCount } from '../DialogDescriptionComponent/CountFile/FileCount';
import { fetchNodeConnectionCount } from '../DialogDescriptionComponent/CountFile/ConnectionCount';
import FobCantonDialog from '../DialogDescriptionComponent/DialogDescriptionType/FobCantonDialog';
import FobCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/FobCantonEditingDialog';
import FobNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/FobNodeCantonEditingDialog';
import PonBoxNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/PonBoxNodeCantonEditingDialog';
import AmplifierNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/AmplifierNodeCantonEditingDialog';
import OpNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/OpNodeCantonEditingDialog';
import DiviredNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/DiviredNodeCantonEditingDialog';
import CassetteNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/CassetteNodeCantonEditingDialog';
import ReserveEditingDialogNode from './DialogEditingNode/ReserveEditingDialogNode';
import ReserveNodeCantonEditingDialog from '../DialogDescriptionComponent/DialogEditingType/ReserveNodeCantonEditingDialog';


const DialogNodeDescroption = ({openModalNode, openModalNodeEnt, handleCloseModal, maxRankCoordinate, filteredCoords, user, cantonRefresh,  role, flag, cantonFobRefresh, cantonPonBoxRefresh}) => {

      const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

      const [openModalEditingPassive, setOpenModalDescriptionPassive] = useState(false);
      const [openModalEditingActivKtv, setOpenModalDescriptionActivKtv] = useState(false);
      const [openModalEditingReserve, setOpenModalDescriptionReserve] = useState(false);
      const [openModalDescription, setOpenModalDescription] = useState(false);
      const [data, setData] = useState([]);
      const [dataKtvAmplifier, setDataKtvAmplifier] = useState([]);
      const [dataDivider, setDataDivider] = useState([]);
      const [id, setId] = useState();
      const [fileCount, setFileCount] = useState(0);
      const [connectionCount, setConnectionCount] = useState(0);
      const [openModalFoto, setOpenModalFoto] = useState(false);
      const [openModalFob, setOpenModalFob] = useState(false);
      const [fobData, setFobData] = useState([]);
      const [openModalPonBox, setOpenModalPonBox] = useState(false);
      const [ponBoxData, setPonBoxData] = useState([]);

      const [openModalAmplifier, setOpenModalAmplifier] = useState(false);
      const [openModalOp, setOpenModalOp] = useState(false);
      const [amplifierData, setAmplifierData] = useState([]);
      const [opData, setOpData] = useState([]);
      const [dividerData, setDividerData] = useState([]);
      const [openModalDivider, setOpenModalDivider] = useState(false);

      const [dataCassette, setDataCassette] = useState([]);
      const [cassetteData, setCassetteData] = useState([]);
      const [openModalCassette, setOpenModalCassette] = useState(false);

      const [openModalReserve, setOpenModalReserve] = useState(false);
      const [dataReserve, setDataReserve] = useState([]);
      const [reserveData, setReserveData] = useState([]);


      const fetchTimeoutRef = useRef(null);

     

      const openModalDescriptionComponents = (id) => {
        if(connectionCount != 0){
          if (!openModalDescription) {
              setOpenModalDescription(true);
              setId(id);
            
          }
        }
    };
    
    const closeModal = () => {
      setOpenModalDescription(false);
      setId();
    };

      const copyToClipboard = (text, type) => {
        const textarea = document.createElement("textarea");
        textarea.value = text; 
        textarea.style.position = "absolute"; 
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);

        textarea.select();
        textarea.focus(); 
    
        try {
            const successful = document.execCommand("copy");
            if (successful) {
               
                showSnackbar('Скопировано: ' + type + ' ID: ' + text, 'snackbarOk');
            } else {
                console.log('Copy failed');
                showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
            }
        } catch (err) {
            console.error('Copy error:', err);
            showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
        }
    
        document.body.removeChild(textarea);
    };
    

      const fetchPonBoxLocationNode = async (hid, entrance) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_PON_BOX_CANTON_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              hid,
              entrance,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове GetPonBoxLocationNode:', error);
          throw error;
        }
      }

      // загрузка резерва
       const fetchReserveNode = async (hid, entrance) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_RESERVE_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              hid,
              entrance,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове fetchReserveNode:', error);
          throw error;
        }
      }

      const openModalFotoFile = () => {     
          setOpenModalFoto(true);
       }; 

       useEffect(() => {
        const fetchData = async () => {
          try {
            const [connectionCount, ponBoxData, ktvAmplifierData, dividerData, cassetteData, reserveData] = await Promise.all([
              fetchNodeConnectionCount(maxRankCoordinate.hid, maxRankCoordinate.entrance),
              fetchPonBoxLocationNode(maxRankCoordinate.hid, maxRankCoordinate.entrance),
              fetchKtvAmplifierNode(maxRankCoordinate.hid, maxRankCoordinate.entrance),
              fetchDividerNode(maxRankCoordinate.hid, maxRankCoordinate.entrance),             
              fetchCassetteNode(maxRankCoordinate.hid, maxRankCoordinate.entrance),
              fetchReserveNode(maxRankCoordinate.hid, maxRankCoordinate.entrance)  
            ]);
      
            if (connectionCount !== null) setConnectionCount(connectionCount);
            if (ponBoxData) setData(ponBoxData);
            if (dividerData) setDataDivider(dividerData);
            if (ktvAmplifierData) setDataKtvAmplifier(ktvAmplifierData);
            if (cassetteData) setDataCassette(cassetteData);
            if (reserveData) setDataReserve(reserveData);
          } catch (err) {
            console.error(err);
          }
        };
      
        fetchData();
      }, [maxRankCoordinate.hid, maxRankCoordinate.entrance]);

     

       useEffect(() => {
         const updateFileCount = async () => {  
           const count = await fetchNodeFileCount(maxRankCoordinate.hid, maxRankCoordinate.entrance);
           if (count !== null) {
             setFileCount(count); 
           }
         };
         updateFileCount();
       });

      const fetchKtvAmplifierNode = async (hid, entrance) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_KTV_AMPLIFIER_OP_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              hid,
              entrance,
            },
          });
          return response.data; // Возвращаем данные от API
        } catch (error) {
          console.error('Ошибка при вызове GetPonBoxLocationNode:', error);
          throw error;
        }
      }

      const fetchDividerNode = async (hid, entrance) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_DIVIDER_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              hid,
              entrance,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове DividerNode:', error);
          throw error;
        }
      }

      const fetchCassetteNode = async (hid, entrance) => {

        const token = localStorage.getItem('token');
        try {
          const response = await axios.get(GET_CASSETTE_NODE_API_URL, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
            params: {
              hid,
              entrance,
            },
          });
          return response.data; 
        } catch (error) {
          console.error('Ошибка при вызове DividerNode:', error);
          throw error;
        }
      }

     

    const openDialogEditingPassive = () => {
      if (!openModalEditingPassive) {
        setOpenModalDescriptionPassive(true);
         
      }
    };

    const openDialogEditingActivKtv = () => {
      if (!openModalEditingActivKtv) {
        setOpenModalDescriptionActivKtv(true);
         
      }
    };

     const openDialogEditingReserve = () => {
      if (!openModalEditingReserve) {
        setOpenModalDescriptionReserve(true);
         
      }
    };

    const handleClick = (item) => {
      if (item.fobId && user === item.authorId) {
        setFobData(item);
        setOpenModalFob(true);
      } else if (item.ponBoxId && user === item.authorId) {
        setPonBoxData(item);
        setOpenModalPonBox(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickKtv = (item) => {
      if (item.ktvAmplifierId && (ROLE_ENGINNER ===  role.role || ROLE_ADMIN ===  role.role)) {
        setAmplifierData(item);
        setOpenModalAmplifier(true);
      } else if (item.opticalReceiverId && (ROLE_ENGINNER ===  role.role || ROLE_ADMIN ===  role.role)) {
        setOpData(item);
        setOpenModalOp(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickReserv = (item) => {
      if (item.reserveNode && (ROLE_ENGINNER ===  role.role || ROLE_ADMIN ===  role.role)) {
        setReserveData(item);
        setOpenModalReserve(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickDivider = (item) => {
      if (item.dividerId && (ROLE_ENGINNER ===  role.role || ROLE_ADMIN ===  role.role)) {
        setDividerData(item);
        setOpenModalDivider(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

    const handleClickCassette = (item) => {
      if (item.cassetteId && (ROLE_ENGINNER ===  role.role || ROLE_ADMIN ===  role.role)) {
        setCassetteData(item);
        setOpenModalCassette(true);
      } else {
        console.log(`Id: Unknown, Type: Unknown`);
      }
    };

  return (
    <Dialog 
      open={(openModalNode !== null) && (openModalNodeEnt !== null)} 
      onClose={handleCloseModal}
      className="dialogNodeStyle"
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      // PaperProps={{
      //   elevation: 0,
      //   style: {
      //     marginTop: "100px",
      //     width: '60%',
      //     height: 'auto',
      //     maxWidth: '60%',
      //     maxHeight: 'auto',
      //   },
      // }}
      PaperProps={{
  elevation: 0,
  className: "dialog-node-paper",
}}
    >
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {/* Адрес */}
          <div className='custom-node-addres'>
              {/* Левый блок с основной информацией */}
              <div>
                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  <a
                    href={`${SERVICE_HOUSE_URL}?Id=${maxRankCoordinate.hid}`}
                    target="_blank"
                    style={{ fontWeight: 'bold', color: 'black' }}
                  >
                    {maxRankCoordinate.street}, дом. {maxRankCoordinate.numberHouse}
                  </a>
                </span>
                <br />
                <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                  Подъезд:
                  <span style={{ color: '#fcc205', fontWeight: 'normal' }}> {maxRankCoordinate.entrance}</span>
                </span>
                <br />
                <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                  ID: <span style={{ color: '#fcc205', fontWeight: 'normal' }}>{maxRankCoordinate.hid}</span>
                </label>
                <Button
                    style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                    onClick={() => { copyToClipboard(maxRankCoordinate.hid, "Дом"); }}>
                      <FileCopyIcon style={{ color: '#e4c253' }} />
                </Button>
              </div>

              {/* Правый блок с кнопками */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                
                <button onClick={() => {openModalDescriptionComponents(maxRankCoordinate.hid);}} className="buttonIsConnectionHouseDialog" style={{ marginTop: '5px', color:"white"}}>
                  Связи
                  <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
                      {connectionCount > 0 ? connectionCount : 'нет'}
                  </span>
                </button>

                <button onClick={openModalFotoFile} className="buttonIsConnectionHouseDialog" style={{ marginTop: '5px', color:"white" }}>
                  Фото узла 
                  <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
                      {fileCount > 0 ? fileCount : 'нет'}
                  </span>
                </button>
              </div>
  
          </div>


          {/* <div style={{ display: 'flex', marginTop: '5px' }}> */}
          <div className="dialog-sections">
              {/* Активка ИНЕТ */}
              <div className='dialog-section-nide'>
                <h3 style={{ fontWeight: 'bold', fontSize: '16px' }}>Активка ИНЕТ ({filteredCoords.length} шт.)</h3>
                <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
                {filteredCoords.length > 0 ? filteredCoords.map((coord, idx) => (
                 
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Ранг:</span> <span style={{ fontSize: '12px' }}>  {coord.rank}</span><br />
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}> {coord.modelSw}</span><br />
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Мак:</span> <span style={{ fontSize: '12px' }}>{coord.mac}</span><br />
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Ip:</span> <span style={{ fontSize: '12px' }}>
                      <a href={`${NETSTAT_SWITCH_URL}?ip=${coord.ip}`} target="_blank" style={{ fontWeight: 'bold', color:"#005fb8" }}>{coord.ip}</a>
                    </span>
                  </div>
                )) : <p>Нет данных для отображения</p>}
          </div>



              {/* Активка КТВ */}
              <div className='dialog-section-nide '>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, marginRight: '10px' }}>Активка КТВ({dataKtvAmplifier.length} шт.)</h3>

                  {(role.role === ROLE_ADMIN || role.role === ROLE_ENGINNER) && (flag === CONST_CANTON) && (
                    <Button
                      style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      onClick={openDialogEditingActivKtv}>
                        <ModeEditIcon style={{ color: '#e4c253' }} />
                    </Button>
                  )}

                </div>
                <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
               
                
                {dataKtvAmplifier.length > 0 ? dataKtvAmplifier.map((item, idx) => (
                  <div key={idx}  
                    className={
                      item.statusKtvAmplifier === 1
                        ? 'custom-box-telecom-ktv-on'
                        : 'custom-box-telecom-ktv-off'
                    } 
                    style={{ marginBottom: '3px' }}  onClick={() => handleClickKtv(item)}>
                   
                    {item.ktvAmplifierId ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img src="./amplifier.png" width="30" height="30" style={{ marginRight: "5px" }} alt="FOB" />
                          <span>Усилитель</span>

                          {/* 👉 иконка справа */}
                          {item.statusKtvAmplifier === 1  ? (
                            <img
                              src="./on.png"
                              width="30"
                              height="30"
                              style={{ marginLeft: "auto" }}
                              alt="on"
                            />
                          ) : (
                            <img
                              src="./off.png"
                              width="30"
                              height="30"
                              style={{ marginLeft: "auto" }}
                              alt="off"
                            />
                          )}
                      </div>

                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                      </>
                    ) : item.opticalReceiverId ? (
                      <>
                        <img src='./op.png' width='30' height='30' style={{ marginRight: "5px" }} alt="PON Box" />
                        <span>Оптический приемник</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                      </>
                    ) : null}
                  </div>
                )) : <p>Нет данных для отображения.</p>}
              </div>


              {/* Резерв */}
              {maxRankCoordinate?.rank === 3 && (
              <div className='dialog-section-nide '>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, marginRight: '10px' }}>Резерв({dataReserve.length} шт.)</h3>

                  {(role.role === ROLE_ADMIN || role.role === ROLE_ENGINNER) && (flag === CONST_CANTON) && (
                    <Button
                      style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      onClick={openDialogEditingReserve}>
                        <ModeEditIcon style={{ color: '#e4c253' }} />
                    </Button>
                  )}

                </div>
                <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
               
                
                {dataReserve.length > 0 ? dataReserve.map((item, idx) => (
                  <div key={idx}  
                    className='custom-box-telecom' 
                    style={{ marginBottom: '3px' }}  onClick={() => handleClickReserv(item)}>
                   
                    {item.reserveNode ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img src="./battery.png" width="30" height="30" style={{ marginRight: "5px" }} alt="FOB" />
                          <span>Резерв</span>                         
                      </div>

                        
                        {/* <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span><br /> */}
                        <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
                        {/* <span>ИБП</span><br/> */}
                        
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель ИБП:</span> <span style={{ fontSize: '12px' }}>  {item.upsModel}</span><br />
                        {item.isUps !== 1 && (
                          <>
                             <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Модель АКБ:</span> <span style={{ fontSize: '12px' }}>  {item.batteryModel}</span><br />
                          </>
                        )}
                         <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Автоном:</span>{" "}
                          <span
                            style={{
                              fontSize: '12px',
                              color: (parseInt(item.backupTime) || 0) < 8 ? '#8B0000' : '#006400',
                              fontWeight: 'bold'
                            }}
                          >
                            {item.backupTime}
                          </span>
                          <br />
                          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Время зарядки:</span> <span style={{ fontSize: '12px' }}>  {item.chargeTime}</span><br />

                         <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Описание:</span> <span style={{ fontSize: '12px' }}>  {item.reserveNodeDescription}</span><br />

                      </>
                   
                    ) : null}
                  </div>
                )) : <p>Нет данных для отображения.</p>}
              </div>
              )}

            {/* Пассивка */}
              <div className='dialog-section-nide'>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 style={{ fontWeight: 'bold', fontSize: '16px', margin: 0, marginRight: '10px' }}>Пассивка({data.length + dataDivider.length + dataCassette.length} шт.)</h3>
                  {(role.role === ROLE_ADMIN || role.role === ROLE_ENGINNER) && (flag === CONST_CANTON) && (
                    <Button
                      style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                      onClick={openDialogEditingPassive}>
                        <ModeEditIcon style={{ color: '#e4c253' }} />
                    </Button>
                  )}
                </div>
                <hr className="horizontalLineDialog2" style={{ marginBottom: "5px" }} />
                {data.length > 0 ? data.map((item, idx) => (
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}  onClick={() => handleClick(item)}>
                   
                    {item.fobId ? (
                      <>
                        <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} alt="FOB" />
                        <span>{FOB_FLAG}</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.fobLocationId}</span>
                        <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.fobLocationId, FOB_FLAG);
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px', filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))'  }} />
                        </Button>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Фоб:</span> <span style={{ fontSize: '12px' }}>  {item.fobName}</span><br />
                      </>
                    ) : item.ponBoxId ? (
                      <>
                     
                        <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} alt="PON Box" />
                        <span>{PON_BOX_FLAG}</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.ponBoxLocationId}</span>
                        <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.ponBoxLocationId, PON_BOX_FLAG);
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px', filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))'  }} />
                        </Button>
                       
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Бокс:</span> <span style={{ fontSize: '12px' }}>  {item.ponBoxName}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Тип прихода:</span> <span style={{ fontSize: '12px' }}>  {item.comingType}</span><br />
                        {/* <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Делитель:</span> <span style={{ fontSize: '12px' }}>  {item.dividerModel}</span><br /> */}

                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Делитель:</span>
                        <div style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', fontWeight: 'normal' }}>
                          <span>{item.dividerModel}</span>
                          {item.divider2Id !== 5 && <span>{item.dividerModel2}</span>}
                        </div>
                      </div>
                      </>
                    ) : null}

                    {/* Общая информация */}
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Внес:</span> <span style={{ fontSize: '12px' }}>  {item.authorId}</span><br />
                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Коммент:</span> <span style={{ fontSize: '12px' }}>  {item.description}</span><br />
                  </div>
                )) : null}

                {dataDivider.length > 0 ? dataDivider.map((item, idx) => (
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}  onClick={() => handleClickDivider(item)}>
                   
                    {item.dividerId ? (
                      <>
                         <img 
                            src={item.polishingId === 1 ? "./divider_upc2.png" : "./divider_apc2.png"} 
                            width="30" 
                            height="30" 
                            style={{ marginRight: "5px" }} 
                            alt="Divider"
                          />
                        <span>Делитель</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span>
                         <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px', filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.id, "Делитель");
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px' }} />
                        </Button>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Делитель:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Затухание:</span> <span style={{ fontSize: '12px' }}>  {item.attenuation} dB</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Признак:</span> 
                        <span style={{ fontSize: '12px' }}>
                          {item.ktvDivider === 1 && item.ponDivider === 1
                            ? ' KTV PON'
                            : item.ktvDivider === 1
                            ? ' KTV'
                            : item.ponDivider === 1
                            ? ' PON'
                            : ' нет'}
                        </span>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Коммент:</span> <span style={{ fontSize: '12px' }}> {item.description}</span><br />
                      </>
                    ) : null} 
                  </div>
                )) : null }

                {dataCassette.length > 0 ? dataCassette.map((item, idx) => (
                  <div key={idx} className='custom-box-telecom' style={{ marginBottom: '3px' }}  onClick={() => handleClickCassette(item)}>
                   
                    {item.cassetteId ? (
                      <>
                         <img 
                            src={"./cassette.png"} 
                            width="35" 
                            height="35" 
                            style={{ marginRight: "5px" }} 
                            alt="Cassette"
                          />
                        <span>Сплайс-кассета</span><br />
                        <hr className="horizontalLineDialog2" style={{ marginTop: "0px" }} />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Id:</span> <span style={{ fontSize: '12px' }}>  {item.id}</span>
                         <Button
                            style={{ marginLeft: '10px', minWidth: '10px', width: '10px', minHeight: '10px', height: '10px',  filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.7))' }}
                            onClick={(event) => {
                                event.stopPropagation(); 
                                copyToClipboard(item.id, "Кассета");
                              }}
                            >
                              <FileCopyIcon style={{ color: '#ffb20b', width: '20px', height: '20px' }} />
                        </Button>
                        <br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Кассета:</span> <span style={{ fontSize: '12px' }}>  {item.model}</span><br />
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Max кол. соединений:</span> <span style={{ fontSize: '12px' }}>  {item.maxWelds}</span><br /> 
                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Коммент:</span> <span style={{ fontSize: '12px' }}> {item.description}</span><br />
                      </>
                    ) : null} 
                  </div>
                )) : null }
              </div>

             
            </div>
        </div>
      </DialogContent>

    {/* Snackbar */}
        <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      /> 

              <ModalDescriptionComponentSpecifically
                open={openModalDescription}
                onClose={closeModal}
                id={id}
                type={HOUSE}
                flag={HOUSE_FLAG}
              />

      {/* Добавление пассивки на узел */}
      <PonBoxEditingDialogNode
        open={openModalEditingPassive}
        onClose={() => setOpenModalDescriptionPassive(false)}
        latitude={maxRankCoordinate.latitude}
        longitude={maxRankCoordinate.longitude}
        canton={maxRankCoordinate.canton}
        area={maxRankCoordinate.vetka}
        user={user}
        cantonRefresh={cantonRefresh}
        hid={maxRankCoordinate.hid}
        entrance={maxRankCoordinate.entrance}
      />

      {/* Добавление КТВ (Усилок, ОП) на узел*/}
      <KtvEditingDialogNode
        open={openModalEditingActivKtv}
        onClose={() => setOpenModalDescriptionActivKtv(false)}
        latitude={maxRankCoordinate.latitude}
        longitude={maxRankCoordinate.longitude}
        canton={maxRankCoordinate.canton}
        area={maxRankCoordinate.vetka}
        user={user}
        cantonRefresh={cantonRefresh}
        hid={maxRankCoordinate.hid}
        entrance={maxRankCoordinate.entrance}
      />

       {/* Добавление резерва на узел*/}
      <ReserveEditingDialogNode
        open={openModalEditingReserve}
        onClose={() => setOpenModalDescriptionReserve(false)}
        latitude={maxRankCoordinate.latitude}
        longitude={maxRankCoordinate.longitude}
        canton={maxRankCoordinate.canton}
        area={maxRankCoordinate.vetka}
        user={user}
        cantonRefresh={cantonRefresh}
        hid={maxRankCoordinate.hid}
        entrance={maxRankCoordinate.entrance}
      />

       {/* Modal Foto*/}
       <DialogNodeFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          hid={maxRankCoordinate.hid}
          entrance={maxRankCoordinate.entrance}
          user={user}  
          role={role.role}   
      />   

      {/* Карточка фоба (редактирование)*/}
      <FobNodeCantonEditingDialog
        open={openModalFob}
        onClose={() => setOpenModalFob(false)}
        content={fobData}
        user={user}   
        cantonFobRefresh={cantonFobRefresh}
        cantonRefresh={cantonRefresh}
      />

      {/* Карточка пон-бокса (редактирование)*/}
      <PonBoxNodeCantonEditingDialog 
       open={openModalPonBox}
       onClose={() => setOpenModalPonBox(false)}
       content={ponBoxData}
       user={user}   
       cantonPonBoxRefresh={cantonPonBoxRefresh}
       cantonRefresh={cantonRefresh}
      />

      {/* Карточка усилителя (редактирование)*/}
      <AmplifierNodeCantonEditingDialog
        open={openModalAmplifier}
        onClose={() => setOpenModalAmplifier(false)}
        content={amplifierData}
        cantonRefresh={cantonRefresh}
      />

       {/* Карточка резерва (редактирование)*/}
      <ReserveNodeCantonEditingDialog
        open={openModalReserve}
        onClose={() => setOpenModalReserve(false)}
        content={reserveData}
        cantonRefresh={cantonRefresh}
      />

      {/* Карточка Делителя (редактирование)*/}
      <DiviredNodeCantonEditingDialog
        open={openModalDivider}
        onClose={() => setOpenModalDivider(false)}
        content={dividerData}
        cantonRefresh={cantonRefresh}
      />

       {/* Карточка Кассеты (редактирование)*/}
       <CassetteNodeCantonEditingDialog
        open={openModalCassette}
        onClose={() => setOpenModalCassette(false)}
        content={cassetteData}
        cantonRefresh={cantonRefresh}
      />

      {/* Карточка ОП (редактирование)*/}
      <OpNodeCantonEditingDialog
        open={openModalOp}
        onClose={() => setOpenModalOp(false)}
        content={opData}
        cantonRefresh={cantonRefresh}
      />

    </Dialog>
  );
};


export default DialogNodeDescroption;